<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
  slots: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['pick']);

const search = ref('');

const filtered = computed(() => {
  if (!search.value) return props.slots;
  const q = search.value.toLowerCase();
  return props.slots.filter(s => (s.slot_name || '').toLowerCase().includes(q));
});

const pick = (slot, attribute) =>
  emit('pick', { token: `{{slot.${slot.slot_name}.${attribute}}}`, slot, attribute });
</script>

<template>
  <div class="text-xs">
    <input
      v-model="search"
      type="text"
      :placeholder="$t('OMNI.SLOTS.API_AUTOMATIONS.SEARCH_SLOTS', 'Buscar slot...')"
      class="w-full px-2 py-1 mb-2 text-xs border border-slate-300 dark:border-slate-600 rounded bg-white dark:bg-slate-700"
    />
    <div
      v-if="!filtered.length"
      class="text-slate-500 italic py-2"
    >
      {{ $t('OMNI.SLOTS.API_AUTOMATIONS.NO_SLOTS', 'Nenhum slot disponível.') }}
    </div>
    <ul
      v-else
      class="max-h-72 overflow-y-auto space-y-0.5 pr-1"
    >
      <li
        v-for="slot in filtered"
        :key="slot.id"
        class="border-b border-slate-100 dark:border-slate-700 last:border-b-0 py-1"
      >
        <div class="flex items-center gap-2 px-1 text-slate-700 dark:text-slate-200 font-mono font-semibold">
          <span class="i-lucide-layers w-3 h-3 text-slate-400" />
          {{ slot.slot_name }}
        </div>
        <div class="flex gap-1 mt-1 px-1">
          <button
            type="button"
            class="flex-1 text-[10px] px-2 py-0.5 rounded border border-slate-200 dark:border-slate-600 hover:bg-woot-50 dark:hover:bg-slate-700"
            @click="pick(slot, 'value')"
          >
            .value
          </button>
          <button
            type="button"
            class="flex-1 text-[10px] px-2 py-0.5 rounded border border-slate-200 dark:border-slate-600 hover:bg-woot-50 dark:hover:bg-slate-700"
            @click="pick(slot, 'status')"
          >
            .status
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>
